import * as types from '../types'
import VueCookies from 'vue-cookies'

export default {
    state: {
        class_id: VueCookies.get("class_id"),
        status: VueCookies.get("class_id")? 1 : 0,
        answer_send:'',
        answer_Receive:'',
        lamp_send:'',
        lamp_Receive:'',
        voter_send:'',
        voter_Receive:'',
        voter_data:null,
        student_white_screen:0,
        score_send:'',
        score_Receive:'',
        score_data:null,
        cutdown_data:null,
        timer_data:null,
        timer_send:'',
        timer_data_event:'',
        timer_data_receive:'',
        downtimer_data_event:'',
        downtimer_data_receive:'',
    },
    mutations: {
        [types.CACHECLASS]: (state, data) => {
            state.class_id = data.class_id;
            state.status = data.status;
        },
        [types.ANSWERSEND]: (state, data) => {
            state.answer_send = data;
        },
        [types.ANSWERRECEIVE]: (state, data) => {
            state.answer_Receive = data;
        },
        [types.SENDLAMPEVENT]: (state, data) => {
            state.lamp_send = data;
        },
        [types.RECELAMPEVENT]: (state, data) => {
            state.lamp_Receive = data;
        },
        [types.SENDVOTEREVENT]: (state, data) => {
            state.voter_send = data;
        },
        [types.RECEVOTEREVENT]: (state, data) => {
            state.voter_Receive = data;
        },
        [types.SENDVOTERDATAEVENT]: (state, data) => {
            state.voter_data = data;
        },
        [types.SENDWHITESCREEN]: (state, data) => {
            state.student_white_screen = data;
        },
        [types.SENDSCOREEVENT]: (state, data) => {
            console.log(data,'~~~~~~~~~~~~~')
            state.score_send = data;
        },
        [types.RECESCOREEVENT]: (state, data) => {
            state.score_Receive = data;
        },
        [types.SENDSCOREDATAEVENT]: (state, data) => {
            console.log(data,'++++++++++++++')
            state.score_data = data;
        },
        [types.TIMERSEND]: (state, data) => {//计时器 数据
            console.log(data,'-------------')
            state.timer_data = data;
        },
        [types.TIMERSENDEVENT]: (state, data) => {//计时器 倒计时  事件
            // console.log(data,'=============')
            state.timer_data_event = data;
        },
        [types.RECETIMERSENDEVENT]: (state, data) => {// 接收 计时器 倒计时 事件
            // console.log(data,'++++++++++')
            state.timer_data_receive = data;
        },
        [types.CUTDOWNSEND]: (state, data) => {//倒计时
            state.cutdown_data = data;
        },
        [types.DOWNTIMERSENDEVENT]: (state, data) => {//计时器 倒计时  事件
            // console.log(data,'=============')
            state.downtimer_data_event = data;
        },
        [types.RECEDOWNTIMERSENDEVENT]: (state, data) => {// 接收 倒计时 事件
            // console.log(data,'++++++++++')
            state.downtimer_data_receive = data;
        },
        [types.LOCKSCREEN]: (state, data) => {//锁屏
            state.lock_screen = data;
        },
        [types.SENDSTOPVIDEOEVENT]: (state, data) => {
            state.stop_video = data;
        },
        [types.SENDPPTPREVIEWEVENT]: (state, data) => {
            state.resource_preview_ppt = data;
        },
    },
    getters: {

    },
    actions: {
    }
}
